import { render, staticRenderFns } from "./FingerList.vue?vue&type=template&id=4561e5a3&scoped=true"
import script from "./FingerList.vue?vue&type=script&lang=js"
export * from "./FingerList.vue?vue&type=script&lang=js"
import style0 from "./FingerList.vue?vue&type=style&index=0&id=4561e5a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561e5a3",
  null
  
)

export default component.exports